module.exports = __webpack_public_path__ + "img/OpenSans-SemiBold.205939dd.svg";